import { PortalNames } from '@dd3tech/wiggui/PortalIcon'

export interface PortalIdProperties {
  portalAllproperty: boolean
  portalCyt: boolean
  portalCytlease: boolean
  portalElinformador: boolean
  portalExcelsior: boolean
  portalI24: boolean
  portalLamudi: boolean
  portalMonopolio: boolean
  portalPortalterrenocom: boolean
  portalPropiedadescom: boolean
  portalWiggot: boolean
  portalM3: boolean
  portalVivanuncios: boolean
  portalMitula: boolean
  portalIcasas: boolean
  portalLahaus: boolean
  portalNeximo: boolean
  portalHoum: boolean
  portalMudafy: boolean
  portalFlatmx: boolean
  portalBeleta: boolean
}

export const idToPropertyMap: Record<keyof PortalIdProperties, string> = {
  portalAllproperty: 'ALLPROPERTY',
  portalCyt: 'CyT',
  portalCytlease: 'CyTlease',
  portalElinformador: 'ELINFORMADOR',
  portalExcelsior: 'EXCELSIOR',
  portalI24: 'I24',
  portalLamudi: 'LAMUDI',
  portalMonopolio: 'MONOPOLIO',
  portalPortalterrenocom: 'PORTALTERRENOCOM',
  portalPropiedadescom: 'PROPIEDADESCOM',
  portalWiggot: 'WIGGOT',
  portalM3: 'M3',
  portalVivanuncios: 'VIVANUNCIOS',
  portalMitula: 'MITULA',
  portalIcasas: 'ICASAS',
  portalLahaus: 'LAHAUS',
  portalNeximo: 'NEXIMO',
  portalHoum: 'HOUM',
  portalMudafy: 'MUDAFY',
  portalFlatmx: 'FLATMX',
  portalBeleta: 'BELETA'
}

export const idToPortalName: Record<PortalNames, string> = {
  allproperty: 'Allproperty',
  cyt: 'Casas y Terrenos',
  cytlease: 'Casas y Terrenos',
  elinformador: 'El informador',
  excelsior: 'Excelsior',
  flatmx: 'Fla Mx',
  houm: 'Houm',
  i24: 'Inmuebles 24',
  icasas: 'ICasas',
  lahaus: 'LaHaus',
  lamudi: 'Lamudi',
  m3: 'Mercado libre',
  mitula: 'Mitula',
  monopolio: 'Monopolio',
  mudafy: 'Mudafy',
  neximo: 'Neximo',
  portalterrenocom: 'Portal Terreno',
  propiedadescom: 'Propiedades.com',
  segundamano: 'Segundamano',
  vivanuncios: 'Viva anuncios',
  wiggot: 'Wiggot',
  beleta: 'Beleta'
}
